// assets/cb-bundle.js
(() => {
  //15-04-2026 helper
  const createBundleKey = (parentId) => {
    if (window.crypto?.randomUUID) {
      return `cb_${parentId}_${crypto.randomUUID()}`;
    }
    return `cb_${parentId}_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  };

  const SELECTORS = {
    bundle: '[data-cb-bundle]',
    item: '[data-cb-item]',
    checkbox: '[data-cb-checkbox]',
    form: 'form[is="product-form"], form[action*="/cart/add"]',
    submitBtn: '[name="add"]',
    stickySubmitBtn: '#custom_add_to_cart_sticky',
    variantInput: 'input[name="id"], select[name="id"]',
    qtyInput: 'input[name="quantity"]',

    // Price targets (main + sticky) - opdater alle
    priceRegularAll: '[data-cb-price]',
    priceSaleAll: '[data-cb-price-sale]',
  };

  const moneyFormat =
    window?.FoxTheme?.settings?.moneyFormat ||
    window?.Shopify?.money_format ||
    '${{amount}}';

  const formatMoney = (cents) => {
    if (window?.FoxTheme?.Currency?.formatMoney) {
      return window.FoxTheme.Currency.formatMoney(cents, moneyFormat);
    }
    const amount = (cents / 100).toFixed(2);
    return moneyFormat.replace('{{amount}}', amount);
  };

  const setLoading = (form, isLoading) => {
    const btn = form.querySelector(SELECTORS.submitBtn);
    if (!btn) return;
    btn.disabled = isLoading;
    btn.classList.toggle('btn--loading', isLoading);
  };

  const getParentState = (form) => {
    const idEl = form.querySelector(SELECTORS.variantInput);
    const id = Number(idEl?.value || 0);
    const quantity = Math.max(1, Number(form.querySelector(SELECTORS.qtyInput)?.value || 1));
    return { id, quantity };
  };

  const getBundleTotalCents = (bundleRoot) => {
    const els = Array.from(bundleRoot.querySelectorAll(SELECTORS.item));
    let total = 0;

    for (const el of els) {
      const cb = el.querySelector(SELECTORS.checkbox);
      if (!cb || cb.disabled || !cb.checked) continue;
      total += Number(el.dataset.variantPrice || 0);
    }
    return total;
  };

  const updateBundlePriceUI = (bundleRoot, qtyOverride = null) => {
    const form = bundleRoot.closest(SELECTORS.form);
    if (!form) return;

    const quantity = qtyOverride ?? getParentState(form).quantity;
    const bundleTotal = getBundleTotalCents(bundleRoot);
    const formatted = formatMoney(bundleTotal * quantity);

    document.querySelectorAll(SELECTORS.priceRegularAll).forEach((el) => {
      el.textContent = formatted;
    });
    document.querySelectorAll(SELECTORS.priceSaleAll).forEach((el) => {
      el.textContent = formatted;
    });
  };

  const initBundlePrice = (bundleRoot) => {
    updateBundlePriceUI(bundleRoot);

    bundleRoot.addEventListener('change', (e) => {
      if (e.target?.matches(SELECTORS.checkbox)) updateBundlePriceUI(bundleRoot);
    });
    bundleRoot.addEventListener('input', (e) => {
      if (e.target?.matches(SELECTORS.checkbox)) updateBundlePriceUI(bundleRoot);
    });

    const form = bundleRoot.closest(SELECTORS.form);
    if (form) {
      const onQty = (e) => {
        if (e.target?.matches(SELECTORS.qtyInput)) updateBundlePriceUI(bundleRoot);
      };
      form.addEventListener('change', onQty);
      form.addEventListener('input', onQty);
    }

    setTimeout(() => updateBundlePriceUI(bundleRoot), 0);
  };

  const getChildItems = (bundleRoot, parentQty) => {
    const els = Array.from(bundleRoot.querySelectorAll(SELECTORS.item));
    const items = [];

    for (const el of els) {
      const variantId = Number(el.dataset.variantId || 0);
      if (!variantId) continue;

      const cb = el.querySelector(SELECTORS.checkbox);
      if (!cb || cb.disabled || !cb.checked) continue;

      items.push({ id: variantId, quantity: parentQty });
    }
    return items;
  };

  const getSectionsForTheme = () => {
    const sections = [];
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
      );
    } catch (_) {}
    return sections;
  };

  const addToCart = async (items) => {
    const url =
      window?.FoxTheme?.routes?.cart_add_url ||
      `${window.Shopify?.routes?.root || '/'}cart/add.js`;

    const sections = getSectionsForTheme();

    const fetchConfig =
      window?.FoxTheme?.utils?.fetchConfig?.('javascript') || {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      };

    const res = await fetch(url, {
      ...fetchConfig,
      body: JSON.stringify({
        items,
        sections,
        sections_url: window.location.pathname,
      }),
    });

    const data = await res.json();
    if (!res.ok || data?.status) throw data;
    return data;
  };

  const openCartDrawerLikeNative = async (parsedState) => {
    if (window?.FoxTheme?.pubsub?.publish && window?.FoxTheme?.routes?.cart_url) {
      const cartRes = await fetch(
        window.FoxTheme.routes.cart_url,
        window.FoxTheme.utils.fetchConfig()
      );
      const cartJson = await cartRes.json();

      cartJson.sections = parsedState?.sections;

      window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        cart: cartJson,
      });

      const drawer = document.querySelector('cart-drawer');
      if (drawer?.show) drawer.show(document.activeElement);
      return;
    }

    window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
  };

  // NEW: sticky button should trigger main form submit flow
  const bindStickyToMainSubmit = (bundleRoot, mainForm) => {
    const stickyBtn = document.querySelector(SELECTORS.stickySubmitBtn);
    if (!stickyBtn) return;

    if (stickyBtn.dataset.cbStickyBound === 'true') return;
    stickyBtn.dataset.cbStickyBound = 'true';

    stickyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      // OPTIONAL (anbefalet): sync qty fra sticky form til main form
      const stickyForm = stickyBtn.closest(SELECTORS.form);
      const stickyQty = stickyForm?.querySelector(SELECTORS.qtyInput)?.value;
      const mainQtyInput = mainForm.querySelector(SELECTORS.qtyInput);
      if (stickyQty && mainQtyInput) {
        mainQtyInput.value = stickyQty;
        // trigger input event så Hyper/price kan reagere
        mainQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        updateBundlePriceUI(bundleRoot, Math.max(1, Number(stickyQty)));
      }

      // Trigger SAME flow as main submit button
      // requestSubmit() er bedst hvis understøttet, ellers dispatch submit event
      if (typeof mainForm.requestSubmit === 'function') {
        mainForm.requestSubmit(mainForm.querySelector(SELECTORS.submitBtn) || undefined);
      } else {
        mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  };

  const initBundle = (bundleRoot) => {
    const form = bundleRoot.closest(SELECTORS.form);
    if (!form) return;

    initBundlePrice(bundleRoot);
    bindStickyToMainSubmit(bundleRoot, form);

    if (form.dataset.cbBundleBound === 'true') return;
    form.dataset.cbBundleBound = 'true';

    form.addEventListener(
      'submit',
      async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const parent = getParentState(form);
        if (!parent.id) {
          alert('Kunne ikke finde hovedproduktets variant (input/select[name="id"]).');
          return;
        }

        const children = getChildItems(bundleRoot, parent.quantity);
        if (!children.length) {
          alert('Vælg mindst én vare i sættet.');
          return;
        }

        const bundleKey = createBundleKey(parent.id);

        const parentItem = {
          id: parent.id,
          quantity: parent.quantity,
          properties: {
            _cb_bundle: bundleKey,
            _cb_role: 'parent',
          },
        };

        const childItems = children.map((it) => ({
          ...it,
          properties: {
            _cb_bundle: bundleKey,
            _cb_role: 'child',
            _cb_parent_variant: String(parent.id),
          },
        }));

        const itemsToAdd = [parentItem, ...childItems];

        setLoading(form, true);
        try {
          const parsedState = await addToCart(itemsToAdd);
          await openCartDrawerLikeNative(parsedState);
        } catch (err) {
          console.error('CB bundle add-to-cart error:', err);
          alert(err?.description || err?.message || 'Der opstod en fejl. Prøv igen.');
        } finally {
          setLoading(form, false);
        }
      },
      true
    );
  };

  const init = () => {
    document.querySelectorAll(SELECTORS.bundle).forEach(initBundle);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
